import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
export function useKeyPress(...targetKey) {
  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        keyPressed = _useState2[0],
        setKeyPressed = _useState2[1];

  useEffect(() => {
    const downHandler = event => {
      if (targetKey.includes(event.key)) {
        setKeyPressed(true);
      }
    };

    const upHandler = event => {
      if (targetKey.includes(event.key)) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey]);
  return keyPressed;
}